var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoIconLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7D5FE6",
  clipPath: "url(#jottacloud_Logo_iconLight.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.64 0v21.333a10.73 10.73 0 0 1-3.09 7.543c-1.977 2-4.66 3.124-7.458 3.124h-4.219V10.667a10.73 10.73 0 0 1 3.09-7.543A10.5 10.5 0 0 1 27.42 0zM0 17.066h4.22a10.5 10.5 0 0 1 7.458 3.124c1.977 2 3.089 4.714 3.089 7.543V32h-4.22a10.5 10.5 0 0 1-7.458-3.124A10.73 10.73 0 0 1 0 21.333z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_Logo_iconLight.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h31.64v32H0z"
})))));
export default SvgLogoIconLight;